import { gql } from '@apollo/client';

export const UPDATE_USER_PERMISSIONS = gql`
    mutation UpdateUserPerms($user_id: Int!, $permissions: [UpdatePermissionInput!]!) {
        updateUserPermissions(user_id: $user_id, permissions: $permissions) {
          user_id
        }
    }
`;
